import { Dispatch, SetStateAction, useEffect } from "react";
import EducationFlow from "../EducationFlow";
import useEducationFlow from "../useEducationFlow";
import { useThreeDPSteps } from "./threeDPSteps";
import { SourcePage } from "@/services/Analytics/EventTypes";
import useLocalStorage from "@/hooks/useLocalStorage";

function ThreeDPEducation({
  isStandAlone,
  setPage,
  finishedEducation,
  setFinishedEducation,
  closeOnBack,
}: {
  isStandAlone: boolean;
  setPage?: Dispatch<SetStateAction<number>>;
  finishedEducation?: boolean;
  setFinishedEducation?: (finishedEducation: boolean) => void;
  closeOnBack: boolean;
}) {
  const steps = useThreeDPSteps(0, isStandAlone);
  const { setValue: setHasSeenFlow } = useLocalStorage("hasSeenThreeDPEducationFlow");

  useEffect(() => {
    setHasSeenFlow(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { activeStep, handleNext, handleBack, handleSkip, bodyRef } = useEducationFlow({
    steps,
    isStandAlone,
    setPage,
    finishedEducation,
    setFinishedEducation,
    closeOnBack,
    analyticsEventName: "3dp_education",
    analyticsSourcePage: SourcePage.threedp_education,
    closePortalId: "threedp",
    nextPage: 1, // placeholder — quiz integration is out of scope
    localStorageKey: "hasSeenThreeDPEducationFlow",
  });

  const currentSteps = useThreeDPSteps(activeStep, isStandAlone);

  return (
    <EducationFlow
      steps={currentSteps}
      activeStep={activeStep}
      handleNext={handleNext}
      handleBack={handleBack}
      handleSkip={handleSkip}
      bodyRef={bodyRef}
      isStandAlone={isStandAlone}
    />
  );
}

export default ThreeDPEducation;
